import deepmerge from 'deepmerge';
import BaseConfig from 'base/config';
import BrandConfig from '@/motherhood/config';

export default deepmerge(BaseConfig, BrandConfig);